"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsNdcBlacklist = void 0;
// TMPP > Pharmacies >  Settings - NDC Blacklist E-059
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx"); // E-059
const mobx_react_1 = require("mobx-react");
const React = require("react");
const store_1 = require("../../../../store");
require("./ndc-blacklist.less");
const store_2 = require("client/modules/inventory/modules/inventory-list/store"); // E-059
const select_1 = require("client/components/material/select"); // E-059
const List_1 = require("material-ui/List"); // E-059
const ArrowDropUp_1 = require("material-ui-icons/ArrowDropUp"); // E-059
const ArrowDropDown_1 = require("material-ui-icons/ArrowDropDown"); // E-059
const confirmation_modal_1 = require("client/components/confirmation-modal");
const material_ui_1 = require("material-ui"); //E-059
const material_ui_icons_1 = require("material-ui-icons"); //E-059
const core_1 = require("@material-ui/core");
const switch_1 = require("client/components/material/switch");
const store_3 = require("client/modules/users/store"); //E-059
const moment = require("moment"); // E-076
const store_4 = require("../../../../../../modules/sites/modules/sites-list/store"); // E-059.810
// E-059
const dummyBlacklist = {
    bin: "",
    id: null,
    name: "",
    pcn: "",
    ndc: "",
    createdAt: "",
    createdBY: "",
    DeletedAt: "",
    modifyBY: "",
    modifyAt: "",
    siteId: "" // E-059.810
};
// TMPP > Pharmacies >  Settings - NDC Blacklist E-059
let AppSettingsNdcBlacklist = class AppSettingsNdcBlacklist extends React.Component {
    constructor(props) {
        super(props);
        this.blacklistData = null; // E-059
        this.blacklistDataForAPI = null;
        this.didUpdate = false;
        this.newBlacklist = dummyBlacklist;
        this.originalBlacklist = null;
        this.warning = "";
        this.isActiveBtnClicked = false; // E-059
        this.isActiveBtnCancel = true; // new  E-059
        this.handleSaveButtonConfirmation = false; // E-059
        this.changed = false;
        this.isAscDesc = false; // E-059
        this.isPcn = false; //E-059
        this.isBin = false; //E-059
        this.isNdcNumber = false; //E-059
        this.siteId = false; // E-059.810
        this.isUserDisable = false; //E-059
        this.isUserCreated = false; //E-059
        this.isUserLastEdit = false; //E-059
        this.isUserDateLastEdit = false; //E-059
        this.hasopenCaret_1 = true; //E-076
        this.hasopenCaret_2 = false; //E-076
        this.hasopenCaret_3 = false; //E-076
        this.hasopenCaret_4 = false; //E-076
        this.hasopenCaret_5 = false; //E-076
        this.hasopenCaret_6 = false; //E-076
        this.hasopenCaret_7 = false; //E-076
        this.hasopenCaret_8 = false; //E-076
        this.confirmationText = 'Disable'; //E-076
        this.hasopenCaret_9 = false; // E-059.810
        this.showDisabledSites = false; // // E-059.810
        this.newExclude = {
            // E-059
            invId: ""
        };
        this.showDisabled = false;
        this.newEntry = {
            reason: "",
            timeout: 0,
            createdBY: ""
            // createdAt: new Date()
        };
        this.handleModalOpenCancel = async () => {
            this.setState({ modelOpenCancel: false });
        };
        this.handleConfirmationModal = () => {
            this.handleSaveButtonConfirmation = true;
        };
        this.handleCancel = async () => {
            this.setState({ isDisabled: true });
            this.setState({ isActive: true });
            this.setState({ modelOpen: false });
            this.setState({ modelOpenCancel: false }); // E-080.3
        };
        this.handleRemove = async () => {
            await this.generateSettings();
            // await this.generateCategoryNames();
            this.setState({ isDisabled: true });
            this.setState({ modelOpenCancel: false });
        };
        this.handleClick = (e) => {
            this.setState({ anchorEl: e.currentTarget });
            this.setState({ resetValue: e.currentTarget });
        };
        this.handleEditDetails = () => {
            this.setState({ modelOpen: true });
            this.setState({ anchorEl: null });
        };
        // E-059
        this.generateSettings = async () => {
            var _a, _b;
            await store_2.inventoryListStore.loadAllInventories(); // E-059
            let result;
            if (this.showDisabled === true) {
                result = await store_1.appSettingsStore.allReadNdcBlacklist();
            }
            else {
                result = await store_1.appSettingsStore.readNdcBlacklist();
            }
            if (result) {
                this.blacklistData = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.sort(this.sortCancellation("name", "asc")); // E-059
            }
            else {
                alert("getting error on copay blacklist");
            }
            this.originalBlacklist = (_b = this.blacklistData) === null || _b === void 0 ? void 0 : _b.map(e => JSON.stringify(e)).toString();
            this.warning = "";
        };
        this.compareDiff = () => {
            const isDiff = this.originalBlacklist !== this.blacklistData.map(e => JSON.stringify(e)).toString();
            this.didUpdate = isDiff;
            if (this.didUpdate) {
                this.warning = "Your changes have not yet been saved.";
                this.forceUpdate();
            }
            else {
                this.warning = "";
            }
        };
        // E-059
        this.showDisableCopayBlacklist = async () => {
            if (this.showDisabled) {
                this.showDisabled = false;
                await this.generateSettings();
            }
            else {
                this.showDisabled = true;
                await this.generateSettings();
            }
        };
        // E-059
        this.handleEdit = (index, value, type) => {
            // newIns.DeletedAt = null;
            // newIns.modifyBY = null;
            let currentUsers = `${store_3.usersStore.user.value.firstName} ${store_3.usersStore.user.value.lastName}`;
            this.blacklistData = this.blacklistData.map((copay, i) => {
                const entry = copay;
                if (i === index) {
                    switch (type) {
                        case "bin":
                            entry.bin = value;
                            break;
                        case "name":
                            entry.name = value;
                            break;
                        case "pcn":
                            entry.pcn = value;
                            break;
                        case "siteId":
                            entry.siteId = value; // E-059.810
                            break;
                        case "ndc":
                            entry.ndc = value;
                            break;
                        case "createdBY":
                            entry.createdBY = value;
                            break;
                        case "createdAt":
                            entry.createdAt = value;
                            break;
                        case "modifyBY":
                            entry.modifyBY = value;
                            break;
                        default:
                            break;
                    }
                    if (entry.name) {
                        entry.modifyBY = currentUsers;
                        entry.modifyAt = new Date();
                    }
                    if (entry.bin)
                        entry.modifyBY = currentUsers;
                    entry.modifyAt = new Date();
                    if (entry.pcn)
                        entry.modifyBY = currentUsers;
                    entry.modifyAt = new Date();
                }
                return entry;
            });
            this.compareDiff();
        };
        this.action_header = {
            color: "#101010",
            fontSize: "14px",
            cursor: "pointer",
            display: "flex" // new css add
        };
        this.main_head = {
            display: "flex",
            justifyContent: "center"
        };
        this.handleAdd = () => {
            const userAdded = `${store_3.usersStore.user.value.firstName} ${store_3.usersStore.user.value.lastName}`;
            const currentDate = new Date();
            const duplicate = this.blacklistData.find(copay => {
                const sameBin = copay.bin === this.newBlacklist.bin;
                const samePcn = copay.pcn === this.newBlacklist.pcn;
                const sameNdc = copay.ndc === this.newBlacklist.ndc; // E-059
                const match = sameBin && samePcn && sameNdc;
                if (match)
                    return copay;
            });
            if (!duplicate) {
                // Create a new entry with DeletedAt and userDisbbleName
                let newEntry = {
                    bin: this.newBlacklist.bin,
                    id: null,
                    name: this.newBlacklist.name,
                    pcn: this.newBlacklist.pcn,
                    ndc: this.newBlacklist.ndc,
                    siteId: this.newBlacklist.siteId,
                    createdAt: currentDate,
                    createdBY: userAdded
                };
                this.blacklistData.push(newEntry);
                this.didUpdate = true;
                this.newBlacklist = dummyBlacklist;
            }
            else {
                this.warning = "This entry already exists!";
            }
        };
        // E-059
        this.handleSubmit = async () => {
            await store_1.appSettingsStore.updateNdcBlacklist(this.blacklistData);
            await this.generateSettings();
            this.didUpdate = false;
            this.handleSaveButtonConfirmation = false;
            this.confirmationText = "Disable";
        };
        this.handleDelete = () => {
            const { isBin, isPcn, isCopayuuId } = this.state;
            const currentUserName = `${store_3.usersStore.user.value.firstName} ${store_3.usersStore.user.value.lastName}`;
            // Use map for transforming objects, and use conditional expressions to correctly update properties
            this.blacklistData = this.blacklistData.map((ins) => {
                if (ins.id === isCopayuuId) {
                    const newIns = Object.assign({}, ins); // Clone the object to avoid direct mutation
                    if (this.confirmationText === "Enable" && newIns.DeletedAt) {
                        newIns.modifyBY = currentUserName;
                        newIns.modifyAt = new Date();
                        newIns.DeletedAt = null; // Enable by setting DeletedAt to null
                    }
                    else if (this.confirmationText === "Disable" && !newIns.DeletedAt) {
                        newIns.modifyBY = currentUserName;
                        newIns.DeletedAt = new Date(); // Disable logic
                        newIns.modifyAt = new Date();
                    }
                    return newIns;
                }
                return ins; // If not matching, return original/
            });
            this.setState({ modelOpenCancel: false });
            this.compareDiff();
        };
        // E-059
        this.handleIconClick = async (copayuuId, _, pcn, bin) => {
            const selectedItem = this.blacklistData.find(item => item.id === copayuuId);
            // Check actual current DeletedAt status
            const isCurrentlyDisabled = !!(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.DeletedAt);
            this.confirmationText = isCurrentlyDisabled ? "Enable" : "Disable";
            // Open confirmation modal and set state
            this.setState({
                modelOpenCancel: true,
                isPcn: pcn,
                isBin: bin,
                isCopayuuId: copayuuId
            });
        };
        this.state = {
            anchorEl: null,
            diloagOpen: false,
            modelOpen: false,
            modelOpenCancel: false,
            warning: "",
            codeItem: "",
            reasonId: null,
            isEditModalOpen: false,
            isDeleteModalOpen: false,
            isPcn: "",
            isBin: "",
            siteId: '',
            isCopayuuId: '',
            resetValue: null
        };
    }
    // E-059.810
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.blacklistData.siteId = store_3.usersStore.user.value.siteId;
        }
        else {
            store_4.sitesListStore.loadSitesNoRelation();
        }
    }
    async componentDidMount() {
        await this.generateSettings();
        await store_4.sitesListStore.loadSitesNoRelation();
    }
    // E-059
    get availableInventory() {
        return store_2.inventoryListStore.inventories.value
            .sort((a, b) => (a.package > b.package ? 1 : -1))
            .map((inventory) => ({
            id: inventory.id,
            label: inventory.package
                ? `${inventory.package} (${inventory.name})`
                : `${inventory.package} (${inventory.name})`,
            tokenLabel: inventory.package
                ? `${inventory.package} (${inventory.name})`
                : `${inventory.package} (${inventory.name})`,
            value: String(inventory.ndc) // E-059 new Changes 
        }));
    }
    // E-059.810
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_4.sitesListStore.sites.value) {
                store_4.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        live: site.live,
                        highlighted: undefined
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString(),
                live: site.live // C-123
            };
            options.push(siteOption);
        }
        return options;
    }
    // E-059
    sortCancellation(key, order = "asc") {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }
            const varA = a[key]
                ? typeof a[key] === "string"
                    ? a[key].toUpperCase()
                    : a[key]
                : "";
            const varB = b[key]
                ? typeof b[key] === "string"
                    ? b[key].toUpperCase()
                    : b[key]
                : "";
            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            }
            else if (varA < varB) {
                comparison = -1;
            }
            return order === "desc" ? comparison * -1 : comparison;
        };
    }
    async componentWillUnmount() {
        this.blacklistData = null;
        await store_4.sitesListStore.loadSitesNoRelation(); // E-059.810
    }
    // git pyu
    renderSettings() {
        var _a, _b, _c, _d;
        const head = React.createElement("h2", null, "NDC Blacklist");
        const subhead = (React.createElement("p", null,
            "The following BIN/PCN/NDC combinations will ",
            React.createElement("em", null, "not"),
            " run  requsts during the claim adjudication process. Names are not required, but duplicate BIN/PCN/NDC  combinations will be ignored."));
        let sortedBlacklistData = this.blacklistData.sort((a, b) => {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
        const insuranceTableHeader = (React.createElement(core_1.TableHead, null,
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isAscDesc = !this.isAscDesc;
                            this.hasopenCaret_1 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_5 = false;
                            this.hasopenCaret_6 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("name", this.isAscDesc ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "Name"),
                        this.hasopenCaret_1 &&
                            (this.isAscDesc ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isBin = !this.isBin;
                            this.hasopenCaret_2 = true;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_5 = false;
                            this.hasopenCaret_6 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("bin", this.isBin ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "BIN"),
                        this.hasopenCaret_2 &&
                            (this.isBin ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isPcn = !this.isPcn;
                            this.hasopenCaret_3 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_5 = false;
                            this.hasopenCaret_6 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("pcn", this.isPcn ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "PCN"),
                        this.hasopenCaret_3 &&
                            (this.isPcn ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.siteId = !this.siteId;
                            this.hasopenCaret_9 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_6 = false;
                            this.hasopenCaret_8 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_7 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("siteId", this.siteId ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "Pharmacy"),
                        this.hasopenCaret_9 &&
                            (this.siteId ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isNdcNumber = !this.isNdcNumber;
                            this.hasopenCaret_8 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_7 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("ndc", this.isNdcNumber ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "NDC"),
                        this.hasopenCaret_8 &&
                            (this.isNdcNumber ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isUserCreated = !this.isUserCreated;
                            this.hasopenCaret_4 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_5 = false;
                            this.hasopenCaret_6 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("createdBY", this.isUserCreated ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "User Created"),
                        this.hasopenCaret_4 &&
                            (this.isUserCreated ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isUserDisable = !this.isUserDisable;
                            this.hasopenCaret_5 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_6 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("createdAt", this.isUserDisable ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "Date Created"),
                        this.hasopenCaret_5 &&
                            (this.isUserDisable ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isUserLastEdit = !this.isUserLastEdit;
                            this.hasopenCaret_6 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_5 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("modifyBY", this.isUserLastEdit ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "User Last Edited"),
                        this.hasopenCaret_6 &&
                            (this.isUserLastEdit ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("div", { className: "tableheadercontent", onClick: (x) => {
                            this.isUserDateLastEdit = !this.isUserDateLastEdit;
                            this.hasopenCaret_7 = true;
                            this.hasopenCaret_2 = false;
                            this.hasopenCaret_1 = false;
                            this.hasopenCaret_3 = false;
                            this.hasopenCaret_4 = false;
                            this.hasopenCaret_6 = false;
                            this.hasopenCaret_8 = false;
                            this.blacklistData = this.blacklistData.sort(this.sortCancellation("modifyAt", this.isUserDateLastEdit ? "desc" : "asc")); // E-076.1
                        } },
                        React.createElement("strong", { style: this.action_header }, "Date Last Edited"),
                        this.hasopenCaret_7 &&
                            (this.isUserDateLastEdit ? (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropUp_1.default, null))) : (React.createElement(List_1.ListItemIcon, null,
                                React.createElement(ArrowDropDown_1.default, null)))))))));
        // E-059
        const rows = this.blacklistData.map((ins, i) => {
            const { bin, name, pcn, siteId, // E-059.810
            ndc, id: copayuuId, createdAt, createdBY, DeletedAt, modifyBY, modifyAt, } = ins;
            const row = (React.createElement(core_1.TableRow, { key: copayuuId || i, className: DeletedAt ? "grey" : "Null" },
                React.createElement(core_1.TableCell, { align: "right" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", disabled: !this.didUpdate, onChange: (event) => this.handleEdit(i, event.target.value, "name"), value: name, color: "secondary", focused: true })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", disabled: !this.didUpdate, onChange: (event) => {
                            this.handleEdit(i, event.target.value, "bin");
                        }, value: bin })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", disabled: !this.didUpdate, onChange: (event) => this.handleEdit(i, event.target.value, "pcn"), value: pcn })),
                React.createElement(core_1.TableCell, { align: "right", className: "insurance-select" },
                    React.createElement(select_1.MaterialSelect, { showDisabledSites: false, backgroundColor: false, options: this.availableOptions, disabled: !this.didUpdate, className: "insurance-data", searchable: true, onSelect: (value) => {
                            if (value === null || value === undefined || value === "") {
                                this.handleEdit(i, "", "siteId");
                            }
                            else {
                                this.handleEdit(i, value, "siteId");
                            }
                        }, onInputKeyDown: (event) => {
                            if (event.key === "Tab" || event.keyCode === 9) {
                                const siteIdValue = String(siteId !== null && siteId !== void 0 ? siteId : "");
                                if (siteIdValue.length === 0) {
                                    event.preventDefault();
                                    const highlighted = this.availableOptions.find(o => o.highlighted);
                                    if (highlighted) {
                                        this.handleEdit(i, highlighted.value, "siteId");
                                    }
                                }
                            }
                        }, value: String(siteId) || "", width: "100%" })),
                React.createElement(core_1.TableCell, { align: "right", className: "insurance-select " },
                    React.createElement(select_1.MaterialSelect, { showDisabledSites: false, backgroundColor: false, className: "insurance-data", searchable: true, disabled: !this.didUpdate, options: this.availableInventory, onSelect: (value) => {
                            if (value === null || value === undefined || value === "") {
                                this.handleEdit(i, "", "ndc");
                            }
                            else {
                                this.handleEdit(i, value, "ndc");
                            }
                        }, onInputKeyDown: (event) => {
                            if (event.key === "Tab" || event.keyCode === 9) {
                                const ndcValue = String(ndc !== null && ndc !== void 0 ? ndc : "");
                                if (ndcValue.length === 0) {
                                    event.preventDefault();
                                    const highlighted = this.availableOptions.find(o => o.highlighted);
                                    if (highlighted) {
                                        this.handleEdit(i, highlighted.value, "ndc");
                                    }
                                }
                            }
                        }, value: ndc || "" })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", disabled: true, 
                        // disabled={!this.didUpdate}
                        onChange: (event) => this.handleEdit(i, event.target.value, "createdBY"), value: ins.createdBY ? ins.createdBY : "" })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", disabled: true, variant: "outlined", className: "custom-textfield", 
                        // disabled={!this.didUpdate}
                        onChange: (event) => this.handleEdit(i, event.target.value, "createdAt"), value: ins.createdAt ? moment(ins.createdAt).format("MM/DD/YYYY") : "" })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", 
                        // disabled={!this.didUpdate}
                        disabled: true, onChange: (event) => this.handleEdit(i, event.target.value, "modifyBY"), value: ins.modifyBY ? ins.modifyBY : "" })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement(core_1.TextField, { multiline: true, rows: 3, placeholder: "", variant: "outlined", className: "custom-textfield", 
                        // disabled={!this.didUpdate}
                        disabled: true, onChange: (event) => this.handleEdit(i, event.target.value, "modifyAt"), value: ins.modifyAt ? moment(ins.modifyAt).format("MM/DD/YYYY") : "" })),
                React.createElement(core_1.TableCell, { align: "right", className: "" },
                    React.createElement("button", { disabled: !this.didUpdate, onClick: async () => {
                            await this.handleIconClick(copayuuId, DeletedAt, pcn, bin);
                        }, style: { width: "fit-content" }, type: "button" }, React.createElement(material_ui_icons_1.MoreVert, null)))));
            return row;
        });
        const newRow = (React.createElement("div", { className: "newentries-container" },
            React.createElement("div", { className: "newentries" },
                React.createElement("div", { className: "newentries-items" },
                    React.createElement(text_field_1.MaterialTextField, { className: "newentries-input", label: "NAME", onChange: (_, v) => {
                            this.newBlacklist.name = v;
                        }, value: ((_a = this.newBlacklist) === null || _a === void 0 ? void 0 : _a.name) || "" })),
                React.createElement("div", { className: "newentries-items" },
                    React.createElement(text_field_1.MaterialTextField, { className: "newentries-input", label: "BIN", onChange: (_, v) => {
                            this.newBlacklist.bin = v;
                        }, value: ((_b = this.newBlacklist) === null || _b === void 0 ? void 0 : _b.bin) || "" })),
                React.createElement("div", { className: "newentries-items" },
                    React.createElement(text_field_1.MaterialTextField, { className: "newentries-input", label: "PCN", onChange: (_, v) => {
                            this.newBlacklist.pcn = v;
                        }, value: ((_c = this.newBlacklist) === null || _c === void 0 ? void 0 : _c.pcn) || "" })),
                React.createElement("div", { className: "newentries-items" },
                    React.createElement(select_1.MaterialSelect, { showDisabledSites: false, backgroundColor: false, options: this.availableOptions, placeholder: "Pharmacy", searchable: true, onSelect: value => {
                            if (value === null || value === undefined || value === '') {
                                this.newBlacklist.siteId = "";
                            }
                            else {
                                this.newBlacklist.siteId = value;
                            }
                        }, onInputKeyDown: (event) => {
                            if (event.key === "Tab" || event.keyCode === 9) {
                                if (this.newBlacklist.siteId.length == 0) {
                                    event.preventDefault();
                                    const highlighted = this.availableOptions.find((o) => o.highlighted);
                                    if (highlighted) {
                                        this.newBlacklist.siteId = highlighted.value;
                                    }
                                }
                            }
                        }, value: String(this.newBlacklist.siteId) || "" })),
                React.createElement("div", { className: "newentries-items" },
                    React.createElement(select_1.MaterialSelect, { showDisabledSites: false, backgroundColor: false, placeholder: "NDC", searchable: true, options: this.availableInventory, onSelect: value => {
                            if (value === null || value === undefined || value === '') {
                                this.newBlacklist.ndc = "";
                            }
                            else {
                                this.newBlacklist.ndc = value;
                            }
                        }, onInputKeyDown: (event) => {
                            if (event.key === "Tab" || event.keyCode === 9) {
                                if (this.newBlacklist.ndc.length == 0) {
                                    event.preventDefault();
                                    const highlighted = this.availableOptions.find((o) => o.highlighted);
                                    if (highlighted) {
                                        this.newBlacklist.ndc = highlighted.value;
                                    }
                                }
                            }
                        }, value: (_d = this.newBlacklist.ndc) !== null && _d !== void 0 ? _d : "" }))),
            React.createElement("div", { style: { display: "flex", gap: 10 } },
                React.createElement(button_1.MaterialButton, { className: "newentires-button", primary: true, onClick: () => this.handleAdd(), style: { marginLeft: "1em", width: "fit-content" }, type: "button", disabled: this.newBlacklist.name.length != 0 ? false : true }, "Add"),
                React.createElement(button_1.MaterialButton, { disabled: !this.didUpdate, primary: true, style: { display: "block", margin: "0 0 0 auto" }, onClick: this.handleConfirmationModal }, "Save")),
            React.createElement("div", { className: "newentries-end" },
                React.createElement(material_ui_1.Button, { className: "cstm-edit-btn", "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: this.handleClick },
                    React.createElement(material_ui_icons_1.MoreVert, null)),
                React.createElement("div", { className: "sites__data__disabled-toggle" },
                    React.createElement(switch_1.MaterialSwitch, { label: "Show Disabled ", value: "showDisabled", 
                        // checked={this.showDisabledSites}
                        onChange: this.showDisableCopayBlacklist })),
                React.createElement(material_ui_1.Menu, { id: "simple-menu", anchorEl: this.state.anchorEl, 
                    // keepMounted={false}
                    open: this.state.anchorEl, onClose: () => {
                        this.didUpdate = true;
                        this.setState({ anchorEl: null });
                    } },
                    React.createElement(material_ui_1.MenuItem, { onClick: async () => {
                            // Ayush
                            this.didUpdate = !this.didUpdate;
                            this.setState({ anchorEl: null });
                            await this.generateSettings();
                        } },
                        React.createElement(material_ui_icons_1.Edit, { style: { marginRight: 15 } }),
                        " Edit")))));
        // 2025-05-06 18:47:27 nandan
        const content = (React.createElement("div", { className: "setting_insurance" },
            React.createElement("div", { className: "insurancesettings-container" },
                React.createElement("div", { className: "Setting-heading" },
                    head,
                    subhead),
                React.createElement("div", { className: "Setting-filter" },
                    React.createElement("h3", null, "Create New Entry"),
                    newRow)),
            React.createElement("div", { className: "setting-insurance-table" },
                React.createElement("h3", null, "Existing List"),
                React.createElement("div", { className: "parent_cancellations insurance-table insuranceTable " },
                    React.createElement("div", { className: "setting-table2" },
                        React.createElement(core_1.Table, { stickyHeader: true, "aria-label": "sticky table" },
                            insuranceTableHeader,
                            React.createElement(core_1.TableBody, null, rows.length ? (rows) : (React.createElement("p", { style: { margin: "0 auto" } }, "Empty")))))))));
        return content;
    }
    // E-059
    render() {
        const didLoad = !!this.blacklistData;
        return (React.createElement("div", null,
            this.handleSaveButtonConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Cancel", message: "Are you sure you would like to edit?", onCancel: () => {
                    this.handleSaveButtonConfirmation = !this.handleSaveButtonConfirmation;
                }, onConfirm: this.handleSubmit, title: "Review confirmation" })),
            this.state.modelOpenCancel && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: this.confirmationText, cancelText: "Cancel", message: `Are you sure you would like to ${this.confirmationText}?`, onCancel: () => {
                    this.setState({ modelOpenCancel: false });
                }, onConfirm: this.handleDelete, 
                // color="primary"
                // autoFocus={true}
                title: `${this.confirmationText} confirmation` })),
            didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "blacklistData", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "blacklistDataForAPI", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "didUpdate", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "newBlacklist", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "warning", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isActiveBtnClicked", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isActiveBtnCancel", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "handleSaveButtonConfirmation", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "changed", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isAscDesc", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isPcn", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isBin", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isNdcNumber", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isUserDisable", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isUserCreated", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isUserLastEdit", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "isUserDateLastEdit", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_1", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_2", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_3", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_4", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_5", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_6", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_7", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_8", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "confirmationText", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "hasopenCaret_9", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "newExclude", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "showDisabled", void 0);
__decorate([
    mobx_1.observable
], AppSettingsNdcBlacklist.prototype, "newEntry", void 0);
__decorate([
    mobx_1.computed
], AppSettingsNdcBlacklist.prototype, "availableInventory", null);
__decorate([
    mobx_1.computed
], AppSettingsNdcBlacklist.prototype, "availableOptions", null);
AppSettingsNdcBlacklist = __decorate([
    mobx_react_1.observer
], AppSettingsNdcBlacklist);
exports.AppSettingsNdcBlacklist = AppSettingsNdcBlacklist;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-insurance/component/ndc-blacklist/ndc-blacklist.tsx
// module id = 3197
// module chunks = 0